/** Dev4 PS new modules topic checkpoints (20 MCQs each). */

export const PS_A_BAYES_QUIZ = [
  {
    prompt: "Bayes theorem: posterior proportional to:",
    options: [
      "likelihood \u00d7 prior",
      "prior / likelihood",
      "marginal only",
      "likelihood only",
    ],
    answer: "A",
    explanation: "Posterior \u221d likelihood \u00d7 prior.",
  },
  {
    prompt: "Prior represents:",
    options: [
      "belief before data",
      "MLE sampling law",
      "Type I error",
      "p-value",
    ],
    answer: "A",
    explanation: "Pre-data uncertainty.",
  },
  {
    prompt: "Conjugate prior for Bernoulli:",
    options: [
      "Beta",
      "Normal",
      "Poisson",
      "Uniform on R",
    ],
    answer: "A",
    explanation: "Beta\u2013Bernoulli conjugacy.",
  },
  {
    prompt: "Beta(\u03b1,\u03b2) + s successes in n trials \u2192 posterior:",
    options: [
      "Beta(\u03b1+s, \u03b2+n-s)",
      "Beta(\u03b1+n, \u03b2+s)",
      "Beta(\u03b1,\u03b2)",
      "Normal",
    ],
    answer: "A",
    explanation: "Successes to \u03b1, failures to \u03b2.",
  },
  {
    prompt: "Flat prior on (0,1) often:",
    options: [
      "Beta(1,1)",
      "Beta(100,100)",
      "point mass 0.5",
      "N(0,1)",
    ],
    answer: "A",
    explanation: "Uniform = Beta(1,1).",
  },
  {
    prompt: "Beta(\u03b1',\u03b2') mean:",
    options: [
      "\u03b1'/(\u03b1'+\u03b2')",
      "\u03b1'\u03b2'",
      "\u03b1'+\u03b2'",
      "\u03b1'-1",
    ],
    answer: "A",
    explanation: "Beta mean formula.",
  },
  {
    prompt: "MAP maximizes:",
    options: [
      "posterior",
      "likelihood only",
      "prior only",
      "evidence only",
    ],
    answer: "A",
    explanation: "Mode of posterior.",
  },
  {
    prompt: "Large n, posterior concentrates near:",
    options: [
      "true \u03b8 and MLE",
      "prior mean only",
      "0",
      "prior mode only",
    ],
    answer: "A",
    explanation: "Consistency.",
  },
  {
    prompt: "Evidence p(x) used for:",
    options: [
      "normalization and model comparison",
      "only prior mean",
      "only SE",
      "replacing likelihood",
    ],
    answer: "A",
    explanation: "Marginal likelihood.",
  },
  {
    prompt: "Normal\u2013normal (known var) posterior is:",
    options: [
      "normal",
      "uniform",
      "Beta",
      "\u03c7\u00b2",
    ],
    answer: "A",
    explanation: "Conjugacy.",
  },
  {
    prompt: "Credible interval:",
    options: [
      "posterior probability mass for \u03b8",
      "same as CI by definition",
      "fixed width",
      "prior only",
    ],
    answer: "A",
    explanation: "Bayesian interval.",
  },
  {
    prompt: "Sequential Bayes:",
    options: [
      "posterior becomes next prior",
      "priors never update",
      "only discrete",
      "likelihood = posterior",
    ],
    answer: "A",
    explanation: "Online updating.",
  },
  {
    prompt: "Jeffreys prior:",
    options: [
      "\u221d \u221aI(\u03b8), reparam-invariant idea",
      "always Beta(1,1)",
      "point at MLE",
      "model-free",
    ],
    answer: "A",
    explanation: "Reference prior.",
  },
  {
    prompt: "Improper prior OK if:",
    options: [
      "\u222b lik\u00d7prior finite positive",
      "prior mean exists",
      "n even",
      "MLE unique",
    ],
    answer: "A",
    explanation: "Proper posterior.",
  },
  {
    prompt: "P(D|+) \u2260 sensitivity because:",
    options: [
      "base rate and FPR enter Bayes",
      "sens only continuous",
      "Bayes N/A",
      "lik=1",
    ],
    answer: "A",
    explanation: "Base rates matter.",
  },
  {
    prompt: "MAP vs MLE:",
    options: [
      "MAP includes prior",
      "MAP ignores data",
      "MAP = prior mode always",
      "MAP minimizes var",
    ],
    answer: "A",
    explanation: "Prior in MAP.",
  },
  {
    prompt: "Poisson rate conjugate prior:",
    options: [
      "Gamma",
      "Beta",
      "Uniform{0,1}",
      "t",
    ],
    answer: "A",
    explanation: "Gamma\u2013Poisson.",
  },
  {
    prompt: "Posterior predictive:",
    options: [
      "new obs after integrating posterior",
      "prior predictive only",
      "MLE sampling only",
      "p-values",
    ],
    answer: "A",
    explanation: "\u222b f(x\u0303|\u03b8)\u03c0(\u03b8|x)d\u03b8.",
  },
  {
    prompt: "Strong prior, weak data \u2192 posterior:",
    options: [
      "near prior",
      "equals MLE",
      "improper",
      "ignores prior",
    ],
    answer: "A",
    explanation: "Prior dominates.",
  },
  {
    prompt: "p(\u03b8|x) =",
    options: [
      "p(x|\u03b8)p(\u03b8)/p(x)",
      "p(x|\u03b8)+p(\u03b8)",
      "p(x)/p(\u03b8)",
      "p(\u03b8)p(x)",
    ],
    answer: "A",
    explanation: "Bayes theorem.",
  },
];

export const PS_A_MLE_QUIZ = [
  {
    prompt: "MLE maximizes:",
    options: [
      "likelihood (or log-likelihood)",
      "prior only",
      "posterior mean",
      "Type I error",
    ],
    answer: "A",
    explanation: "Definition.",
  },
  {
    prompt: "Bernoulli MLE with s/n:",
    options: [
      "s/n",
      "s",
      "n/s",
      "1/2",
    ],
    answer: "A",
    explanation: "Sample proportion.",
  },
  {
    prompt: "Normal \u03bc (\u03c3 known) MLE:",
    options: [
      "x\u0304",
      "median",
      "mode",
      "0",
    ],
    answer: "A",
    explanation: "Sample mean.",
  },
  {
    prompt: "MLE invariance: g(\u03b8\u0302) is MLE of:",
    options: [
      "g(\u03b8)",
      "always unbiased g",
      "prior mean",
      "never holds",
    ],
    answer: "A",
    explanation: "Functional invariance.",
  },
  {
    prompt: "Asymptotic law of \u221an(\u03b8\u0302\u2212\u03b8\u2080):",
    options: [
      "N(0,1/I(\u03b8\u2080))",
      "Uniform",
      "\u03c7\u00b2\u2081",
      "degenerate",
    ],
    answer: "A",
    explanation: "Fisher information.",
  },
  {
    prompt: "Fisher information measures:",
    options: [
      "expected curvature of log-likelihood",
      "only n",
      "prior var",
      "p-value",
    ],
    answer: "A",
    explanation: "I(\u03b8).",
  },
  {
    prompt: "Score is:",
    options: [
      "\u2202\u2113/\u2202\u03b8",
      "posterior mode",
      "LR",
      "CDF",
    ],
    answer: "A",
    explanation: "Gradient of \u2113.",
  },
  {
    prompt: "Critical point of \u2113:",
    options: [
      "score = 0",
      "score = 1",
      "I=0",
      "L=prior",
    ],
    answer: "A",
    explanation: "FOC.",
  },
  {
    prompt: "Non-unique MLE when:",
    options: [
      "flat likelihood region",
      "n odd",
      "improper prior",
      "continuous data",
    ],
    answer: "A",
    explanation: "Flat L.",
  },
  {
    prompt: "Uniform(0,\u03b8) MLE:",
    options: [
      "X_{(n)}",
      "x\u0304",
      "min",
      "n x\u0304",
    ],
    answer: "A",
    explanation: "Sample max.",
  },
  {
    prompt: "Bias of \u03b8\u0302:",
    options: [
      "E[\u03b8\u0302]\u2212\u03b8",
      "Var(\u03b8\u0302)",
      "MSE only",
      "prior mean",
    ],
    answer: "A",
    explanation: "Definition.",
  },
  {
    prompt: "Consistency means:",
    options: [
      "\u03b8\u0302 \u2192_p \u03b8\u2080",
      "unbiased all n",
      "Var=0 all n",
      "equals MAP",
    ],
    answer: "A",
    explanation: "In probability.",
  },
  {
    prompt: "Profile likelihood:",
    options: [
      "maximizes out nuisance params",
      "conjugate prior",
      "MCAR only",
      "discrete only",
    ],
    answer: "A",
    explanation: "Nuisance.",
  },
  {
    prompt: "MLE = MAP when prior is:",
    options: [
      "flat",
      "highly informative",
      "Jeffreys only",
      "missing",
    ],
    answer: "A",
    explanation: "Flat prior.",
  },
  {
    prompt: "Poisson \u03bb MLE:",
    options: [
      "x\u0304",
      "s\u00b2",
      "max",
      "1/x\u0304",
    ],
    answer: "A",
    explanation: "Mean.",
  },
  {
    prompt: "Observed information:",
    options: [
      "\u2212\u2113''(\u03b8\u0302)",
      "prior precision",
      "n only",
      "p-value",
    ],
    answer: "A",
    explanation: "Hessian.",
  },
  {
    prompt: "Boundary MLE:",
    options: [
      "standard asymptotics may fail",
      "always OK",
      "always unbiased",
      "I=\u221e",
    ],
    answer: "A",
    explanation: "Non-regular.",
  },
  {
    prompt: "Why log-likelihood:",
    options: [
      "sums, numerical stability",
      "changes maximizer",
      "no data needed",
      "equals prior",
    ],
    answer: "A",
    explanation: "log product\u2192sum.",
  },
  {
    prompt: "Method of moments vs MLE:",
    options: [
      "may differ",
      "always equal",
      "always more efficient",
      "ignores L",
    ],
    answer: "A",
    explanation: "Different criteria.",
  },
  {
    prompt: "CRLB for unbiased estimators:",
    options: [
      "Var \u2265 1/(n I(\u03b8))",
      "Var \u2265 0 only",
      "prior var",
      "n I",
    ],
    answer: "A",
    explanation: "Cram\u00e9r\u2013Rao.",
  },
];

export const PS_A_CI_QUIZ = [
  {
    prompt: "95% CI means:",
    options: [
      "95% of repeated samples cover true \u03b8",
      "\u03b8 random with prob 0.95",
      "posterior 0.95",
      "p=0.05",
    ],
    answer: "A",
    explanation: "Coverage.",
  },
  {
    prompt: "Known \u03c3, 95% CI for \u03bc:",
    options: [
      "x\u0304 \u00b1 1.96 \u03c3/\u221an",
      "x\u0304 \u00b1 \u03c3",
      "x\u0304 \u00b1 1.96\u03c3",
      "[0,1]",
    ],
    answer: "A",
    explanation: "z-interval.",
  },
  {
    prompt: "Unknown \u03c3 uses:",
    options: [
      "t_{n-1} and s/\u221an",
      "z=1.96 always",
      "\u03c7\u00b2 only",
      "F only",
    ],
    answer: "A",
    explanation: "t-interval.",
  },
  {
    prompt: "Larger n:",
    options: [
      "shortens CI",
      "widens",
      "same width",
      "coverage 0",
    ],
    answer: "A",
    explanation: "SE\u221d1/\u221an.",
  },
  {
    prompt: "99% vs 95% CI:",
    options: [
      "wider",
      "narrower",
      "same",
      "independent of level",
    ],
    answer: "A",
    explanation: "Higher confidence.",
  },
  {
    prompt: "Confidence level 1\u2212\u03b1:",
    options: [
      "long-run coverage of procedure",
      "posterior prob",
      "1\u2212p always",
      "power",
    ],
    answer: "A",
    explanation: "Definition.",
  },
  {
    prompt: "Wald 95% for proportion:",
    options: [
      "p\u0302 \u00b1 1.96\u221a(p\u0302(1\u2212p\u0302)/n)",
      "p\u0302 \u00b1 1.96",
      "p\u0302 \u00b1 \u221an",
      "[0,1]",
    ],
    answer: "A",
    explanation: "Wald.",
  },
  {
    prompt: "Bootstrap CI:",
    options: [
      "resample to approximate sampling variability",
      "needs normal prior",
      "Bayesian only",
      "ignores sample",
    ],
    answer: "A",
    explanation: "Resampling.",
  },
  {
    prompt: "CI excludes 0 for difference \u21d2",
    options: [
      "two-sided \u03b1=0.05 test rejects H0: diff=0",
      "p exactly 0.05",
      "large effect",
      "BF=\u221e",
    ],
    answer: "A",
    explanation: "Duality.",
  },
  {
    prompt: "Margin of error:",
    options: [
      "half-width of CI",
      "bias",
      "prior SD",
      "Type II",
    ],
    answer: "A",
    explanation: "MoE.",
  },
  {
    prompt: "Variance CI (normal data):",
    options: [
      "\u03c7\u00b2 pivot on (n\u22121)s\u00b2/\u03c3\u00b2",
      "only z",
      "Beta",
      "Poisson",
    ],
    answer: "A",
    explanation: "Chi-square.",
  },
  {
    prompt: "One-sided bound:",
    options: [
      "upper or lower at stated level",
      "always shorter",
      "no coverage meaning",
      "equals credible",
    ],
    answer: "A",
    explanation: "One-sided CI.",
  },
  {
    prompt: "Asymptotic MLE CI:",
    options: [
      "\u03b8\u0302 \u00b1 z / \u221a(n I(\u03b8\u0302))",
      "range only",
      "exact binomial only",
      "credible only",
    ],
    answer: "A",
    explanation: "Wald asymptotic.",
  },
  {
    prompt: "Coverage probability:",
    options: [
      "P_\u03b8(\u03b8 \u2208 C(X))",
      "exactly 1\u2212\u03b1 all finite n",
      "posterior mass",
      "L at MLE",
    ],
    answer: "A",
    explanation: "May be approx.",
  },
  {
    prompt: "Paired mean difference CI:",
    options: [
      "use paired differences",
      "add two z-intervals",
      "pooled unpaired only",
      "Bayesian only",
    ],
    answer: "A",
    explanation: "Paired.",
  },
  {
    prompt: "Wilson/Agresti\u2013Coull:",
    options: [
      "better small-n coverage than Wald",
      "worse always",
      "need Bayes prior",
      "ignore n",
    ],
    answer: "A",
    explanation: "Improved interval.",
  },
  {
    prompt: "Very wide CI means:",
    options: [
      "need more data / less noise",
      "\u03b8 nonexistent",
      "MLE biased",
      "\u03b1 too small only",
    ],
    answer: "A",
    explanation: "Uncertainty.",
  },
  {
    prompt: "Many parameters simultaneous CIs:",
    options: [
      "need multiplicity adjustment",
      "no adjustment",
      "only Bonferroni on p",
      "Bayes only",
    ],
    answer: "A",
    explanation: "Family-wise.",
  },
  {
    prompt: "CI is random because:",
    options: [
      "function of random sample X",
      "\u03b8 random in frequentist theory",
      "\u03b1 random",
      "prior random",
    ],
    answer: "A",
    explanation: "C(X).",
  },
  {
    prompt: "Prediction interval vs CI:",
    options: [
      "targets new observation",
      "always equal CI",
      "ignores variance",
      "Bayes only",
    ],
    answer: "A",
    explanation: "PI for future Y.",
  },
];

export const PS_A_MGF_QUIZ = [
  {
    prompt: "MGF is:",
    options: [
      "M(t)=E[e^{tX}]",
      "E[X^t]",
      "E[log X]",
      "CDF",
    ],
    answer: "A",
    explanation: "Definition.",
  },
  {
    prompt: "E[X] from MGF:",
    options: [
      "M'(0)",
      "M(0)",
      "M''(0)",
      "M'(1)",
    ],
    answer: "A",
    explanation: "First derivative.",
  },
  {
    prompt: "Var from MGF:",
    options: [
      "M''(0)\u2212[M'(0)]\u00b2",
      "M'(0)",
      "M(0)",
      "1/M''(0)",
    ],
    answer: "A",
    explanation: "Second moment.",
  },
  {
    prompt: "Independent sum MGF:",
    options: [
      "product of MGFs",
      "sum of MGFs",
      "max",
      "undefined",
    ],
    answer: "A",
    explanation: "Independence.",
  },
  {
    prompt: "N(\u03bc,\u03c3\u00b2) MGF:",
    options: [
      "exp(\u03bct + \u03c3\u00b2t\u00b2/2)",
      "exp(\u03bct) only",
      "(1\u2212t)^{-1}",
      "e^t/(1\u2212t)",
    ],
    answer: "A",
    explanation: "Normal MGF.",
  },
  {
    prompt: "Exp(rate \u03bb) MGF:",
    options: [
      "\u03bb/(\u03bb\u2212t) for t<\u03bb",
      "e^{\u03bbt}",
      "1/(1\u2212t)",
      "\u03bbe^{\u2212\u03bbt}",
    ],
    answer: "A",
    explanation: "Exponential.",
  },
  {
    prompt: "MGF uniqueness when:",
    options: [
      "exists in nbhd of 0",
      "only at 0",
      "mean finite",
      "discrete only",
    ],
    answer: "A",
    explanation: "Uniqueness thm.",
  },
  {
    prompt: "Discrete nonnegative MGF:",
    options: [
      "\u03a3 e^{tk} P(X=k)",
      "\u03a3 k^t P",
      "PGF only",
      "\u221e always",
    ],
    answer: "A",
    explanation: "Sum form.",
  },
  {
    prompt: "Y=aX+b \u21d2 M_Y(t)=",
    options: [
      "e^{bt} M_X(at)",
      "M_X(t)+a+b",
      "a M_X+b",
      "M_X^a",
    ],
    answer: "A",
    explanation: "Affine rule.",
  },
  {
    prompt: "Bernoulli(p) MGF:",
    options: [
      "1\u2212p+p e^t",
      "p e^t",
      "e^{pt}",
      "(1\u2212p)e^t",
    ],
    answer: "A",
    explanation: "Two-point.",
  },
  {
    prompt: "Bin(n,p) MGF:",
    options: [
      "(1\u2212p+p e^t)^n",
      "1\u2212p+p e^t",
      "e^{npt}",
      "(p e^t)^n",
    ],
    answer: "A",
    explanation: "n i.i.d. Bern.",
  },
  {
    prompt: "Poisson(\u03bb) MGF:",
    options: [
      "exp(\u03bb(e^t\u22121))",
      "exp(\u03bbt)",
      "\u03bb/(\u03bb\u2212t)",
      "(1\u2212t)^{\u2212\u03bb}",
    ],
    answer: "A",
    explanation: "Poisson.",
  },
  {
    prompt: "No MGF near 0:",
    options: [
      "moments may still exist; heavy tails",
      "no mean possible",
      "no CDF",
      "not RV",
    ],
    answer: "A",
    explanation: "e.g. issues.",
  },
  {
    prompt: "Cumulant GF:",
    options: [
      "log M(t)",
      "M'(t)",
      "1/M",
      "M\u00b2",
    ],
    answer: "A",
    explanation: "K=log M.",
  },
  {
    prompt: "First cumulant:",
    options: [
      "mean",
      "variance",
      "skew",
      "kurtosis",
    ],
    answer: "A",
    explanation: "K'(0).",
  },
  {
    prompt: "Second cumulant:",
    options: [
      "variance",
      "mean",
      "skew",
      "mode",
    ],
    answer: "A",
    explanation: "K''(0).",
  },
  {
    prompt: "CLT via MGF uses:",
    options: [
      "log M(t/\u221an) \u2192 quadratic",
      "only simulation",
      "CF always",
      "Bayes priors",
    ],
    answer: "A",
    explanation: "Classic proof.",
  },
  {
    prompt: "Gamma(\u03b1, rate \u03bb) MGF:",
    options: [
      "(\u03bb/(\u03bb\u2212t))^\u03b1",
      "e^{\u03b1t}",
      "\u03bb/(\u03bb\u2212t) only \u03b1=1",
      "undefined",
    ],
    answer: "A",
    explanation: "Gamma.",
  },
  {
    prompt: "Same MGF near 0 \u21d2",
    options: [
      "same distribution",
      "same mean only",
      "same var only",
      "nothing",
    ],
    answer: "A",
    explanation: "Uniqueness.",
  },
  {
    prompt: "E[X^k] =",
    options: [
      "M^{(k)}(0)",
      "M(k)",
      "M'(k)",
      "k! M(0)",
    ],
    answer: "A",
    explanation: "k-th derivative.",
  },
];

export const PS_B_ANOVA_QUIZ = [
  {
    prompt: "One-way ANOVA tests:",
    options: [
      "equality of k\u22652 means",
      "medians only",
      "variances only",
      "proportions only",
    ],
    answer: "A",
    explanation: "Means.",
  },
  {
    prompt: "F statistic:",
    options: [
      "MSB/MSW",
      "MSW/MSB",
      "sum of obs",
      "median",
    ],
    answer: "A",
    explanation: "Ratio.",
  },
  {
    prompt: "Under H0, F ~",
    options: [
      "F(k\u22121,N\u2212k)",
      "N(0,1)",
      "t_{N\u22121}",
      "\u03c7\u00b2_k",
    ],
    answer: "A",
    explanation: "F law.",
  },
  {
    prompt: "SST =",
    options: [
      "SSB+SSW",
      "SSB only",
      "SSW only",
      "SSB\u2212SSW",
    ],
    answer: "A",
    explanation: "Partition.",
  },
  {
    prompt: "Large F suggests:",
    options: [
      "between \u226b within noise",
      "identical means",
      "only var differ",
      "n=1",
    ],
    answer: "A",
    explanation: "Signal.",
  },
  {
    prompt: "ANOVA assumes:",
    options: [
      "indep, normal, equal var (approx)",
      "only equal n",
      "Bayes priors",
      "none",
    ],
    answer: "A",
    explanation: "Classical.",
  },
  {
    prompt: "Post-hoc after significant ANOVA:",
    options: [
      "which pairs differ",
      "replace F",
      "only variances",
      "prior",
    ],
    answer: "A",
    explanation: "Multiple comparisons.",
  },
  {
    prompt: "Two-way ANOVA assesses:",
    options: [
      "two factors + interaction",
      "one factor only",
      "only slopes",
      "only p",
    ],
    answer: "A",
    explanation: "Factorial.",
  },
  {
    prompt: "Interaction means:",
    options: [
      "effect of A depends on B",
      "factors independent always",
      "means equal",
      "errors correlated only",
    ],
    answer: "A",
    explanation: "Non-additive.",
  },
  {
    prompt: "Fan-shaped residuals:",
    options: [
      "heteroscedasticity concern",
      "normality OK",
      "F exact always",
      "n=\u221e",
    ],
    answer: "A",
    explanation: "Unequal var.",
  },
  {
    prompt: "Kruskal\u2013Wallis is:",
    options: [
      "nonparametric one-way ANOVA",
      "paired t",
      "only regression",
      "\u03c7\u00b2 GOF",
    ],
    answer: "A",
    explanation: "Ranks.",
  },
  {
    prompt: "Effect size often:",
    options: [
      "\u03b7\u00b2 or \u03c9\u00b2",
      "only p",
      "only F",
      "prior mean",
    ],
    answer: "A",
    explanation: "Variance explained.",
  },
  {
    prompt: "Balanced design:",
    options: [
      "equal/proportional n",
      "equal means",
      "var=0",
      "n=1",
    ],
    answer: "A",
    explanation: "Balance.",
  },
  {
    prompt: "MSE estimates:",
    options: [
      "common \u03c3\u00b2",
      "only between var",
      "grand mean",
      "MLE bias",
    ],
    answer: "A",
    explanation: "Within MS.",
  },
  {
    prompt: "Omnibus null:",
    options: [
      "\u03bc1=\u22ef=\u03bck",
      "equal var only",
      "medians differ",
      "\u03b2=0 only",
    ],
    answer: "A",
    explanation: "Equal means.",
  },
  {
    prompt: "df between (k groups):",
    options: [
      "k\u22121",
      "k",
      "N\u2212k",
      "N\u22121",
    ],
    answer: "A",
    explanation: "k\u22121.",
  },
  {
    prompt: "df within:",
    options: [
      "N\u2212k",
      "k\u22121",
      "N\u22121",
      "k",
    ],
    answer: "A",
    explanation: "N\u2212k.",
  },
  {
    prompt: "Log transform sometimes:",
    options: [
      "stabilize variance",
      "always \u2191F",
      "no data needed",
      "\u2191p always",
    ],
    answer: "A",
    explanation: "Remedial.",
  },
  {
    prompt: "Fixed effects:",
    options: [
      "specific levels of interest",
      "random sample of levels",
      "Bayes RE only",
      "unrelated",
    ],
    answer: "A",
    explanation: "Fixed.",
  },
  {
    prompt: "Significant ANOVA, nonsig pairs after correction:",
    options: [
      "omnibus power > pairwise",
      "ANOVA wrong",
      "\u03b1=1",
      "invalid data",
    ],
    answer: "A",
    explanation: "Power.",
  },
];

export const PS_B_CHISQ_QUIZ = [
  {
    prompt: "\u03c7\u00b2 GOF tests:",
    options: [
      "observed vs hypothesized frequencies",
      "equal means",
      "slopes",
      "corr=1",
    ],
    answer: "A",
    explanation: "GOF.",
  },
  {
    prompt: "Independence test for:",
    options: [
      "contingency table association",
      "paired continuous only",
      "one mean",
      "normal var",
    ],
    answer: "A",
    explanation: "Tables.",
  },
  {
    prompt: "E_ij under independence:",
    options: [
      "R_i C_j / N",
      "O_ij",
      "N",
      "R_i only",
    ],
    answer: "A",
    explanation: "Expected.",
  },
  {
    prompt: "\u03a3(O\u2212E)\u00b2/E \u2248",
    options: [
      "\u03c7\u00b2 with suitable df",
      "N(0,1) always",
      "t_{N\u22121}",
      "F(1,1)",
    ],
    answer: "A",
    explanation: "Pearson.",
  },
  {
    prompt: "df for r\u00d7c independence:",
    options: [
      "(r\u22121)(c\u22121)",
      "rc",
      "r+c",
      "N\u22121",
    ],
    answer: "A",
    explanation: "Product.",
  },
  {
    prompt: "Approximation better when:",
    options: [
      "expected counts not too small",
      "all O=0",
      "N=2",
      "one cell",
    ],
    answer: "A",
    explanation: "Rule of thumb.",
  },
  {
    prompt: "Fisher exact preferred when:",
    options: [
      "small tables / low expected",
      "N huge always",
      "continuous",
      "means",
    ],
    answer: "A",
    explanation: "Exact.",
  },
  {
    prompt: "Yates correction:",
    options: [
      "more conservative 2\u00d72",
      "\u2191 Type I always",
      "ANOVA only",
      "no E needed",
    ],
    answer: "A",
    explanation: "Continuity.",
  },
  {
    prompt: "Homogeneity tests:",
    options: [
      "distributions across groups",
      "mean=0",
      "normal var",
      "R\u00b2",
    ],
    answer: "A",
    explanation: "Homogeneity.",
  },
  {
    prompt: "Standardized residual:",
    options: [
      "which cells drive signal",
      "mean",
      "\u03c3 in ANOVA",
      "replace p",
    ],
    answer: "A",
    explanation: "Cells.",
  },
  {
    prompt: "McNemar for:",
    options: [
      "paired binary",
      "independent 2\u00d72 only",
      "continuous paired",
      "Poisson only",
    ],
    answer: "A",
    explanation: "Paired.",
  },
  {
    prompt: "G\u00b2 vs Pearson:",
    options: [
      "asymptotically equivalent under H0",
      "always smaller",
      "needs Bayes",
      "ignores E",
    ],
    answer: "A",
    explanation: "LR \u03c7\u00b2.",
  },
  {
    prompt: "O=E all cells:",
    options: [
      "statistic 0",
      "\u221e",
      "df=0",
      "invalid",
    ],
    answer: "A",
    explanation: "Perfect fit.",
  },
  {
    prompt: "\u03c7\u00b2 law is:",
    options: [
      "sum of squares of indep N(0,1)",
      "symmetric about 0",
      "same as t",
      "Uniform[0,1]",
    ],
    answer: "A",
    explanation: "Definition.",
  },
  {
    prompt: "GOF p-value:",
    options: [
      "P(\u03c7\u00b2_df \u2265 obs)",
      "always 0.05",
      "1\u2212F_obs",
      "prior",
    ],
    answer: "A",
    explanation: "Upper tail.",
  },
  {
    prompt: "Simpson paradox:",
    options: [
      "aggregation can reverse association",
      "\u03c7\u00b2 never works",
      "indep always",
      "df wrong",
    ],
    answer: "A",
    explanation: "Confounding.",
  },
  {
    prompt: "Odds ratio 2\u00d72:",
    options: [
      "ad/bc association",
      "mean diff",
      "var ratio",
      "rank corr only",
    ],
    answer: "A",
    explanation: "OR.",
  },
  {
    prompt: "Large \u03c7\u00b2 with large N:",
    options: [
      "may be tiny practical effect",
      "always important",
      "impossible",
      "proves cause",
    ],
    answer: "A",
    explanation: "n effect.",
  },
  {
    prompt: "GOF df with m estimated params, k bins:",
    options: [
      "k\u22121\u2212m",
      "k",
      "k\u2212m",
      "N\u2212k",
    ],
    answer: "A",
    explanation: "Adjust.",
  },
  {
    prompt: "\u03c7\u00b2 does not prove:",
    options: [
      "causation",
      "freq differ from E",
      "association",
      "GOF",
    ],
    answer: "A",
    explanation: "Assoc\u2260cause.",
  },
];

export const PS_B_NONPARAM_QUIZ = [
  {
    prompt: "Mann\u2013Whitney compares:",
    options: [
      "two independent samples (ranks)",
      "paired means only",
      "normal variances",
      "MLR coeffs",
    ],
    answer: "A",
    explanation: "Two-sample ranks.",
  },
  {
    prompt: "Wilcoxon signed-rank:",
    options: [
      "paired/one-sample ranks of diffs",
      "two independent only",
      "tables",
      "ANOVA only",
    ],
    answer: "A",
    explanation: "Paired ranks.",
  },
  {
    prompt: "Nonparametric useful when:",
    options: [
      "normality doubtful / ordinal data",
      "exactly normal always",
      "n\u2192\u221e only",
      "priors known",
    ],
    answer: "A",
    explanation: "Robust.",
  },
  {
    prompt: "MW under null uses:",
    options: [
      "combined-sample ranks",
      "raw means only",
      "MLEs only",
      "\u03c7\u00b2 E",
    ],
    answer: "A",
    explanation: "Rank sums.",
  },
  {
    prompt: "Kruskal\u2013Wallis extends:",
    options: [
      "MW to k groups",
      "paired t to reg",
      "\u03c7\u00b2 to means",
      "MLE to MAP",
    ],
    answer: "A",
    explanation: "k groups.",
  },
  {
    prompt: "Spearman is:",
    options: [
      "Pearson of ranks",
      "Pearson raw only",
      "always = Kendall",
      "partial only",
    ],
    answer: "A",
    explanation: "Rank corr.",
  },
  {
    prompt: "Kendall tau:",
    options: [
      "concordant/discordant pairs",
      "only linear raw",
      "equal var",
      "Bayes factors",
    ],
    answer: "A",
    explanation: "Concordance.",
  },
  {
    prompt: "Sign test uses:",
    options: [
      "only signs of differences",
      "full parametric L",
      "\u03c7\u00b2 tables only",
      "F ratios",
    ],
    answer: "A",
    explanation: "Signs.",
  },
  {
    prompt: "Rank vs t under normality:",
    options: [
      "small efficiency loss; gain under heavy tails",
      "always more power normal",
      "larger \u03b1 needed",
      "ignore n",
    ],
    answer: "A",
    explanation: "Tradeoff.",
  },
  {
    prompt: "Ties handled by:",
    options: [
      "average ranks (+ corrections)",
      "delete all data",
      "ranks=0",
      "ignore sample",
    ],
    answer: "A",
    explanation: "Midranks.",
  },
  {
    prompt: "Permutation tests:",
    options: [
      "reshuffle labels for null",
      "need normal residuals",
      "Bayes only",
      "ignore statistic",
    ],
    answer: "A",
    explanation: "Randomization.",
  },
  {
    prompt: "Hodges\u2013Lehmann:",
    options: [
      "robust location (Wilcoxon-related)",
      "MLE normal only",
      "\u03c7\u00b2 E",
      "prior mode",
    ],
    answer: "A",
    explanation: "HL estimator.",
  },
  {
    prompt: "MW assumptions:",
    options: [
      "indep samples; identical cont. laws under null",
      "equal means only",
      "normal required",
      "paired",
    ],
    answer: "A",
    explanation: "iid groups.",
  },
  {
    prompt: "Ordinal data:",
    options: [
      "rank methods often better than means t-tests",
      "only ANOVA valid",
      "MLE impossible",
      "no \u03c7\u00b2",
    ],
    answer: "A",
    explanation: "Scale.",
  },
  {
    prompt: "Friedman test:",
    options: [
      "blocked/repeated-measures ranks",
      "two-sample t only",
      "Y on X only",
      "var=1",
    ],
    answer: "A",
    explanation: "Blocks.",
  },
  {
    prompt: "Power nonparametric vs parametric:",
    options: [
      "depends on true law",
      "always lower",
      "always higher",
      "indep of n",
    ],
    answer: "A",
    explanation: "Context.",
  },
  {
    prompt: "Bootstrap gives:",
    options: [
      "nonparametric CIs/tests",
      "only parametric MLE",
      "only Bayes post",
      "exact normal always",
    ],
    answer: "A",
    explanation: "Resample.",
  },
  {
    prompt: "Sign test downside:",
    options: [
      "ignores magnitudes \u2192 less power",
      "higher Type I always",
      "needs normality",
      "can't rank",
    ],
    answer: "A",
    explanation: "Efficiency.",
  },
  {
    prompt: "Van der Waerden:",
    options: [
      "normal quantile scores",
      "Bayes priors",
      "\u03c7\u00b2 residuals",
      "ignore ranks",
    ],
    answer: "A",
    explanation: "Normal scores.",
  },
  {
    prompt: "Nonparametric \u2260 assumption-free:",
    options: [
      "independence/iid under null still matter",
      "no assumptions",
      "\u03b1 irrelevant",
      "n=1",
    ],
    answer: "A",
    explanation: "Still assumptions.",
  },
];

export const PS_B_MLR_QUIZ = [
  {
    prompt: "MLR model:",
    options: [
      "Y=\u03b20+\u03b21X1+\u2026+\u03b2pXp+\u03b5",
      "Y=\u03b20 only",
      "logistic only",
      "Y indep of X",
    ],
    answer: "A",
    explanation: "Linear in \u03b2.",
  },
  {
    prompt: "OLS minimizes:",
    options: [
      "sum of squared residuals",
      "sum abs only",
      "Cauchy L only",
      "prior var",
    ],
    answer: "A",
    explanation: "Least squares.",
  },
  {
    prompt: "OLS matrix form:",
    options: [
      "\u03b2\u0302=(X\u1d40X)\u207b\u00b9X\u1d40y",
      "\u03b2\u0302=X\u207b\u00b9y always",
      "\u03b2\u0302=0",
      "\u03b2\u0302=Xy",
    ],
    answer: "A",
    explanation: "Normal eqns.",
  },
  {
    prompt: "R\u00b2 is:",
    options: [
      "fraction of Var(Y) explained",
      "p-value",
      "causal size only",
      "prior R\u00b2",
    ],
    answer: "A",
    explanation: "Fit.",
  },
  {
    prompt: "Adjusted R\u00b2:",
    options: [
      "penalizes extra predictors",
      "only \u2193n",
      "neg residuals",
      "missing only",
    ],
    answer: "A",
    explanation: "Penalty.",
  },
  {
    prompt: "Multicollinearity:",
    options: [
      "predictors nearly linear \u2192 unstable \u03b2\u0302",
      "errors normal",
      "Y binary",
      "n<p always",
    ],
    answer: "A",
    explanation: "Collinearity.",
  },
  {
    prompt: "VIF diagnoses:",
    options: [
      "multicollinearity",
      "normality Y",
      "homo only",
      "outliers only",
    ],
    answer: "A",
    explanation: "VIF.",
  },
  {
    prompt: "Residual plots check:",
    options: [
      "linearity, hetero, outliers",
      "only prior",
      "only R\u00b2",
      "MLE unique",
    ],
    answer: "A",
    explanation: "Diagnostics.",
  },
  {
    prompt: "Gauss\u2013Markov: OLS is:",
    options: [
      "BLUE",
      "MLE under Cauchy",
      "biased always",
      "inconsistent always",
    ],
    answer: "A",
    explanation: "BLUE.",
  },
  {
    prompt: "Normal errors \u21d2 OLS =",
    options: [
      "MLE of \u03b2",
      "MAP spiked prior only",
      "MoM var only",
      "\u03c7\u00b2 min",
    ],
    answer: "A",
    explanation: "Normal L.",
  },
  {
    prompt: "t-test for \u03b2_j:",
    options: [
      "H0: \u03b2_j=0 typically",
      "overall fit only",
      "equal var groups",
      "table indep",
    ],
    answer: "A",
    explanation: "Single coef.",
  },
  {
    prompt: "Overall F tests:",
    options: [
      "all slopes jointly 0",
      "one \u03b2_j only",
      "normality",
      "homo",
    ],
    answer: "A",
    explanation: "Omnibus.",
  },
  {
    prompt: "Dummy variables:",
    options: [
      "encode categories",
      "only continuous interactions",
      "missingness always",
      "residual var",
    ],
    answer: "A",
    explanation: "Indicators.",
  },
  {
    prompt: "Interaction \u03b212 X1 X2:",
    options: [
      "effect of X1 depends on X2",
      "X1\u22a5X2",
      "errors interact",
      "R\u00b2=1",
    ],
    answer: "A",
    explanation: "Moderation.",
  },
  {
    prompt: "Heteroscedasticity:",
    options: [
      "Var(\u03b5) depends on X",
      "mean \u03b5 \u22600 only",
      "collinear X",
      "small n",
    ],
    answer: "A",
    explanation: "Nonconst var.",
  },
  {
    prompt: "Robust SEs:",
    options: [
      "valid under hetero",
      "always \u2193 bias \u03b2\u0302",
      "need normality",
      "ignore X",
    ],
    answer: "A",
    explanation: "Sandwich.",
  },
  {
    prompt: "Cook's distance:",
    options: [
      "influential points",
      "leverage only no residual",
      "collinearity",
      "missing Y",
    ],
    answer: "A",
    explanation: "Influence.",
  },
  {
    prompt: "High leverage:",
    options: [
      "unusual X (large h_ii)",
      "always large residual",
      "zero residual",
      "missing X",
    ],
    answer: "A",
    explanation: "Hat.",
  },
  {
    prompt: "Polynomial reg still linear because:",
    options: [
      "linear in coefficients",
      "linear in X always",
      "Y polynomial",
      "\u03b5 polynomial",
    ],
    answer: "A",
    explanation: "In \u03b2.",
  },
  {
    prompt: "CV / train-test:",
    options: [
      "out-of-sample prediction",
      "exact p under H0 always",
      "replace OLS",
      "guarantee cause",
    ],
    answer: "A",
    explanation: "Predictive.",
  },
];

export const PS_C_JOINT_QUIZ = [
  {
    prompt: "Joint continuous PDF:",
    options: [
      "P((X,Y)\u2208A)=\u222c_A f",
      "f_X=f_{X,Y} all y",
      "margins multiply always",
      "CDF=PDF",
    ],
    answer: "A",
    explanation: "Definition.",
  },
  {
    prompt: "Marginal of X:",
    options: [
      "\u222b f(x,y) dy",
      "f(x,y)",
      "f_Y",
      "F_{X,Y}",
    ],
    answer: "A",
    explanation: "Integrate y.",
  },
  {
    prompt: "Independence iff:",
    options: [
      "f(x,y)=f_X f_Y a.e.",
      "E[XY]=0",
      "Var(X+Y)=VarX+VarY only",
      "Cov=1",
    ],
    answer: "A",
    explanation: "Factor.",
  },
  {
    prompt: "f(y|x)=",
    options: [
      "f(x,y)/f_X(x)",
      "f_X/f joint",
      "f_Y always",
      "F",
    ],
    answer: "A",
    explanation: "Conditional.",
  },
  {
    prompt: "Cov(X,Y)=",
    options: [
      "E[XY]\u2212E[X]E[Y]",
      "E[X]+E[Y]",
      "VarX VarY",
      "E[X/Y]",
    ],
    answer: "A",
    explanation: "Cov.",
  },
  {
    prompt: "\u03c1 =",
    options: [
      "Cov/(\u03c3x \u03c3y)",
      "Cov only",
      "E[XY]",
      "Var(X+Y)",
    ],
    answer: "A",
    explanation: "Correlation.",
  },
  {
    prompt: "|\u03c1|\u22641 equality when:",
    options: [
      "Y affine in X a.s.",
      "independent",
      "means 0",
      "infinite var",
    ],
    answer: "A",
    explanation: "Cauchy\u2013Schwarz.",
  },
  {
    prompt: "Discrete joint PMF sums to:",
    options: [
      "1",
      "0",
      "margin X only",
      "\u221e",
    ],
    answer: "A",
    explanation: "Normalize.",
  },
  {
    prompt: "E[Y|X=x] is:",
    options: [
      "function of x",
      "always E[Y]",
      "indep of joint",
      "mode of X",
    ],
    answer: "A",
    explanation: "Regression fn.",
  },
  {
    prompt: "Law total expectation:",
    options: [
      "E[E[Y|X]]=E[Y]",
      "E[Y|X] only",
      "Var Y",
      "E[X|Y]",
    ],
    answer: "A",
    explanation: "Tower.",
  },
  {
    prompt: "Cov=0 means:",
    options: [
      "uncorrelated, not nec. independent",
      "independent always",
      "Var(X+Y)=0",
      "means equal",
    ],
    answer: "A",
    explanation: "Uncorr.",
  },
  {
    prompt: "Joint CDF F(a,b)=",
    options: [
      "P(X\u2264a,Y\u2264b)",
      "f(a,b)",
      "F_X+F_Y",
      "P(X=a,Y=b)",
    ],
    answer: "A",
    explanation: "CDF.",
  },
  {
    prompt: "Indep \u21d2 Var(X+Y)=",
    options: [
      "VarX+VarY",
      "VarX VarY",
      "VarX\u2212VarY",
      "0",
    ],
    answer: "A",
    explanation: "Additivity.",
  },
  {
    prompt: "Convolution for X+Y needs:",
    options: [
      "independence",
      "only uncorr",
      "X=Y",
      "n=1",
    ],
    answer: "A",
    explanation: "Indep.",
  },
  {
    prompt: "Support of joint:",
    options: [
      "where f>0",
      "always rectangle",
      "unit square",
      "empty if corr",
    ],
    answer: "A",
    explanation: "Support.",
  },
  {
    prompt: "Law total variance:",
    options: [
      "E[Var(Y|X)]+Var(E[Y|X])=Var Y",
      "Var(Y|X)=Var Y always",
      "indep of law X",
      "0 if uncorr",
    ],
    answer: "A",
    explanation: "Decomposition.",
  },
  {
    prompt: "Copulas separate:",
    options: [
      "margins from dependence",
      "mean from var only",
      "PDF from CDF only",
      "prior from post",
    ],
    answer: "A",
    explanation: "Sklar.",
  },
  {
    prompt: "Continuous P(X=x,Y=y)=",
    options: [
      "0",
      "f(x,y)",
      "1",
      "F",
    ],
    answer: "A",
    explanation: "No atoms.",
  },
  {
    prompt: "Jacobian when:",
    options: [
      "transforming joint densities",
      "only means",
      "defining indep",
      "OLS \u03b2",
    ],
    answer: "A",
    explanation: "Change var.",
  },
  {
    prompt: "Mutual info 0 when:",
    options: [
      "independent",
      "\u03c1=1",
      "means differ",
      "vars differ",
    ],
    answer: "A",
    explanation: "I=0\u21d2indep.",
  },
];

export const PS_C_MVN_QUIZ = [
  {
    prompt: "MVN means:",
    options: [
      "every a\u1d40X univariate normal",
      "only margins normal",
      "only diag \u03a3",
      "finite mean only",
    ],
    answer: "A",
    explanation: "Definition.",
  },
  {
    prompt: "MVN determined by:",
    options: [
      "\u03bc and \u03a3",
      "mean only",
      "corr without vars",
      "mode only",
    ],
    answer: "A",
    explanation: "Params.",
  },
  {
    prompt: "Diag \u03a3 for MVN \u21d2",
    options: [
      "independent components",
      "only uncorr dependent",
      "margins not normal",
      "\u03bc=0",
    ],
    answer: "A",
    explanation: "Gaussian.",
  },
  {
    prompt: "Density uses:",
    options: [
      "exp(\u2212\u00bd (x\u2212\u03bc)\u1d40\u03a3\u207b\u00b9(x\u2212\u03bc)) / \u221a|\u03a3|",
      "det only",
      "trace only",
      "uniform",
    ],
    answer: "A",
    explanation: "Quadratic form.",
  },
  {
    prompt: "Affine AX+b of MVN:",
    options: [
      "MVN",
      "uniform",
      "Poisson",
      "univ normal only if square A",
    ],
    answer: "A",
    explanation: "Closure.",
  },
  {
    prompt: "Conditionals in MVN:",
    options: [
      "normal, linear conditional mean",
      "uniform on sphere",
      "discrete",
      "indep of \u03a3",
    ],
    answer: "A",
    explanation: "Conditionals.",
  },
  {
    prompt: "Mahalanobis:",
    options: [
      "(x\u2212\u03bc)\u1d40\u03a3\u207b\u00b9(x\u2212\u03bc)",
      "Euclidean only",
      "L1",
      "tr \u03a3",
    ],
    answer: "A",
    explanation: "Distance.",
  },
  {
    prompt: "Singular \u03a3:",
    options: [
      "degenerate on lower-dim subspace",
      "larger density",
      "indep fails always",
      "no mean",
    ],
    answer: "A",
    explanation: "Degenerate.",
  },
  {
    prompt: "Whitening:",
    options: [
      "uncorrelated / standard coords",
      "Poisson vector",
      "ranks",
      "binary",
    ],
    answer: "A",
    explanation: "\u03a3^{\u22121/2}.",
  },
  {
    prompt: "Quadratic forms X\u1d40AX:",
    options: [
      "\u03c7\u00b2 / generalized \u03c7\u00b2 under conditions",
      "uniform always",
      "Bernoulli",
      "t_1 always",
    ],
    answer: "A",
    explanation: "Theory.",
  },
  {
    prompt: "Partial correlation:",
    options: [
      "linear assoc controlling others",
      "mean only",
      "n only",
      "prior",
    ],
    answer: "A",
    explanation: "Partial.",
  },
  {
    prompt: "Bivariate normal \u03c1=0 \u21d2",
    options: [
      "independent",
      "only uncorr dependent",
      "Y discrete",
      "no density",
    ],
    answer: "A",
    explanation: "Special.",
  },
  {
    prompt: "MLE of \u03bc i.i.d. MVN:",
    options: [
      "sample mean vector",
      "median vector always",
      "0",
      "prior mode",
    ],
    answer: "A",
    explanation: "x\u0304.",
  },
  {
    prompt: "Sample covariance estimates:",
    options: [
      "\u03a3",
      "\u03bc only",
      "\u03c1 only",
      "precision only",
    ],
    answer: "A",
    explanation: "S.",
  },
  {
    prompt: "Precision \u03a3\u207b\u00b9 encodes:",
    options: [
      "conditional dependence (GGM)",
      "only marginal vars",
      "mean",
      "n",
    ],
    answer: "A",
    explanation: "Zeros.",
  },
  {
    prompt: "Hotelling T\u00b2 generalizes:",
    options: [
      "one-sample t to mean vector",
      "ANOVA F only",
      "\u03c7\u00b2 GOF",
      "MW",
    ],
    answer: "A",
    explanation: "Multivariate t.",
  },
  {
    prompt: "MVN contours:",
    options: [
      "Mahalanobis ellipsoids",
      "circles always",
      "squares",
      "indep of \u03a3",
    ],
    answer: "A",
    explanation: "Ellipses.",
  },
  {
    prompt: "Gaussian linear regression link:",
    options: [
      "conditional mean of joint MVN",
      "logistic only",
      "rank reg only",
      "Poisson GLM only",
    ],
    answer: "A",
    explanation: "Conditionals.",
  },
  {
    prompt: "Simulate MVN via:",
    options: [
      "Cholesky Lz, z~N(0,I)",
      "mean only",
      "replace density",
      "ranks",
    ],
    answer: "A",
    explanation: "Factor.",
  },
  {
    prompt: "Margins of MVN:",
    options: [
      "normal",
      "uniform",
      "heavy tails always",
      "discrete",
    ],
    answer: "A",
    explanation: "Marginal.",
  },
];

export const PS_C_STOCH_QUIZ = [
  {
    prompt: "Stochastic process is:",
    options: [
      "family of RVs indexed by time/space",
      "single RV",
      "only MC",
      "deterministic t",
    ],
    answer: "A",
    explanation: "Definition.",
  },
  {
    prompt: "Markov property:",
    options: [
      "future \u22a5 past | present",
      "future \u22a5 present",
      "indep increments always",
      "Gaussian margins only",
    ],
    answer: "A",
    explanation: "Memoryless state.",
  },
  {
    prompt: "Transition matrix P:",
    options: [
      "rows nonnegative sum to 1",
      "det=1 always",
      "neg entries free",
      "cols sum 0",
    ],
    answer: "A",
    explanation: "Stochastic matrix.",
  },
  {
    prompt: "Stationary \u03c0:",
    options: [
      "\u03c0\u1d40=\\\u03c0\u1d40P, sums to 1",
      "\u03c0=P",
      "\u03c0=0",
      "P\u03c0=0",
    ],
    answer: "A",
    explanation: "Invariant.",
  },
  {
    prompt: "Finite irreducible aperiodic MC:",
    options: [
      "\u2192 unique stationary from any start",
      "many limits always",
      "zero measure",
      "deterministic cycle always",
    ],
    answer: "A",
    explanation: "Ergodic.",
  },
  {
    prompt: "Poisson process has:",
    options: [
      "indep increments, Poisson counts",
      "dep increments always",
      "jumps size 2 fixed",
      "Gaussian only",
    ],
    answer: "A",
    explanation: "PP.",
  },
  {
    prompt: "Poisson interarrivals:",
    options: [
      "i.i.d. Exp(\u03bb)",
      "deterministic 1/\u03bb only",
      "U(0,1)",
      "Normal",
    ],
    answer: "A",
    explanation: "Gaps.",
  },
  {
    prompt: "Brownian motion:",
    options: [
      "continuous paths, indep Gaussian increments",
      "jumps fixed times",
      "discrete state",
      "indep of t",
    ],
    answer: "A",
    explanation: "Wiener.",
  },
  {
    prompt: "Martingale:",
    options: [
      "E[X_{t+1}|F_t]=X_t",
      "Var \u2193 always",
      "mean 0 always",
      "Markov only",
    ],
    answer: "A",
    explanation: "Fair game.",
  },
  {
    prompt: "Absorbing state i:",
    options: [
      "P_ii=1",
      "P_ii=0",
      "equal to all",
      "\u03c0_i=0 always",
    ],
    answer: "A",
    explanation: "Trap.",
  },
  {
    prompt: "Detailed balance \u21d2",
    options: [
      "\u03c0 stationary (reversible)",
      "periodic chain",
      "no stationary",
      "P symmetric always",
    ],
    answer: "A",
    explanation: "Reversible.",
  },
  {
    prompt: "CTMC holding time:",
    options: [
      "Exponential",
      "deterministic",
      "Uniform",
      "Poisson counts",
    ],
    answer: "A",
    explanation: "Memoryless.",
  },
  {
    prompt: "Simple RW on Z:",
    options: [
      "MC; recurrent in 1D",
      "Poisson process",
      "always transient 1D",
      "exact BM",
    ],
    answer: "A",
    explanation: "RW.",
  },
  {
    prompt: "Generator Q:",
    options: [
      "nonpos diag, rows sum 0",
      "rows sum 1",
      "only positive",
      "det 1",
    ],
    answer: "A",
    explanation: "Rates.",
  },
  {
    prompt: "Ergodicity: time averages \u2192",
    options: [
      "ensemble under stationary law",
      "initial only",
      "0 always",
      "max state",
    ],
    answer: "A",
    explanation: "Long-run.",
  },
  {
    prompt: "Branching processes:",
    options: [
      "population via offspring dist",
      "only Poisson arrivals",
      "BM bridges",
      "linear reg",
    ],
    answer: "A",
    explanation: "GW.",
  },
  {
    prompt: "Cross-link with LA Markov module:",
    options: [
      "steady-state vectors / spectral P",
      "only BM",
      "only ANOVA",
      "only MLE",
    ],
    answer: "A",
    explanation: "Cross-link.",
  },
  {
    prompt: "Hitting time:",
    options: [
      "first time reaching a set",
      "stationary mass",
      "rate only",
      "MGF",
    ],
    answer: "A",
    explanation: "First passage.",
  },
  {
    prompt: "Independent increments:",
    options: [
      "nonoverlap intervals independent changes",
      "Markov fails",
      "cont state only",
      "\u03c0 unique always",
    ],
    answer: "A",
    explanation: "L\u00e9vy ingredient.",
  },
  {
    prompt: "Gambler's ruin uses:",
    options: [
      "absorbing Markov chains",
      "only PP",
      "only MVN",
      "OLS",
    ],
    answer: "A",
    explanation: "Classic MC.",
  },
];

export const PS_C_CLT_QUIZ = [
  {
    prompt: "Classical CLT:",
    options: [
      "\u221an(X\u0304\u2212\u03bc)/\u03c3 \u21d2 N(0,1)",
      "X\u0304 \u2192 N(\u03bc,\u03c3\u00b2)",
      "nX\u0304 Poisson",
      "s\u00b2\u21920 only",
    ],
    answer: "A",
    explanation: "Lindeberg\u2013L\u00e9vy.",
  },
  {
    prompt: "SE of X\u0304 \u2248",
    options: [
      "s/\u221an",
      "s",
      "s/n",
      "n/s",
    ],
    answer: "A",
    explanation: "SE.",
  },
  {
    prompt: "Sampling dist of X\u0304 large n:",
    options: [
      "\u2248 N(\u03bc, \u03c3\u00b2/n)",
      "population scaled",
      "Uniform",
      "Cauchy always",
    ],
    answer: "A",
    explanation: "CLT.",
  },
  {
    prompt: "WLLN:",
    options: [
      "X\u0304\u2192_p \u03bc (finite mean)",
      "X\u0304=\u03bc exact finite n",
      "Var \u2191 with n",
      "CLT without scale",
    ],
    answer: "A",
    explanation: "LLN.",
  },
  {
    prompt: "Finite population correction when:",
    options: [
      "without replacement finite pop",
      "n\u2192\u221e only",
      "paired data",
      "Bayes priors",
    ],
    answer: "A",
    explanation: "FPC.",
  },
  {
    prompt: "Slutsky helps:",
    options: [
      "combine \u2192_d with \u2192_p",
      "only LLN",
      "replace CLT",
      "estimate priors",
    ],
    answer: "A",
    explanation: "Slutsky.",
  },
  {
    prompt: "Delta method:",
    options: [
      "g(\u03b8\u0302) asymptotics via g'",
      "only exact finite sample",
      "only ranks",
      "only PP",
    ],
    answer: "A",
    explanation: "Taylor+CLT.",
  },
  {
    prompt: "Var of p\u0302 \u2248",
    options: [
      "p(1\u2212p)/n",
      "p/n",
      "1/n",
      "p(1\u2212p)",
    ],
    answer: "A",
    explanation: "Bernoulli.",
  },
  {
    prompt: "t-statistic (normal data):",
    options: [
      "exact t; \u2248N large n",
      "exact N all n",
      "\u03c7\u00b2",
      "F(1,1)",
    ],
    answer: "A",
    explanation: "Studentize.",
  },
  {
    prompt: "Berry\u2013Esseen bounds:",
    options: [
      "CLT rate via 3rd moments",
      "mean only",
      "Bayes post only",
      "prior var",
    ],
    answer: "A",
    explanation: "Rate.",
  },
  {
    prompt: "No finite variance:",
    options: [
      "classical CLT may fail",
      "still always holds",
      "uniform margins",
      "implies indep",
    ],
    answer: "A",
    explanation: "Need \u03c3\u00b2<\u221e.",
  },
  {
    prompt: "Bootstrap approximates:",
    options: [
      "sampling dist by resampling",
      "draws from prior only",
      "analytic MGF only",
      "\u03c3 known always",
    ],
    answer: "A",
    explanation: "Bootstrap.",
  },
  {
    prompt: "Asymptotic CI for \u03bc:",
    options: [
      "x\u0304 \u00b1 z s/\u221an",
      "range only",
      "exact binom only",
      "credible only",
    ],
    answer: "A",
    explanation: "Wald.",
  },
  {
    prompt: "Sampling distribution:",
    options: [
      "law of statistic over repeated samples",
      "population law",
      "posterior",
      "prior predictive",
    ],
    answer: "A",
    explanation: "Key idea.",
  },
  {
    prompt: "Sum S_n of i.i.d. finite var:",
    options: [
      "approx normal large n",
      "Var(S_n)=\u03c3\u00b2",
      "S_n/n\u00b2\u2192N(0,1)",
      "E S_n=0 always",
    ],
    answer: "A",
    explanation: "Sum CLT.",
  },
  {
    prompt: "Edgeworth refines:",
    options: [
      "CLT with skew/kurtosis",
      "only LLN",
      "only exact t",
      "Bayes MAP",
    ],
    answer: "A",
    explanation: "Higher order.",
  },
  {
    prompt: "Plugin SE:",
    options: [
      "replace \u03c3 by consistent \u03c3\u0302",
      "needs known \u03bc",
      "ignores n",
      "prior only",
    ],
    answer: "A",
    explanation: "Feasible.",
  },
  {
    prompt: "Multivariate CLT:",
    options: [
      "\u221an mean vector \u2192 MVN",
      "univ means only",
      "Poisson limits only",
      "ranks only",
    ],
    answer: "A",
    explanation: "Vector CLT.",
  },
  {
    prompt: "Small n + skew:",
    options: [
      "CLT approx can be poor",
      "always exact",
      "equals t always",
      "skew irrelevant",
    ],
    answer: "A",
    explanation: "Caution.",
  },
  {
    prompt: "WLLN needs:",
    options: [
      "E|X|<\u221e under i.i.d.",
      "only \u03c3\u00b2<\u221e",
      "only normal",
      "never",
    ],
    answer: "A",
    explanation: "Finite mean.",
  },
];
